module.exports = __webpack_public_path__ + "static/media/gts06.aae5c620.png";